import { render, staticRenderFns } from "./FixedBtnView.vue?vue&type=template&id=1e456c0b"
import script from "./FixedBtnView.vue?vue&type=script&lang=js"
export * from "./FixedBtnView.vue?vue&type=script&lang=js"
import style0 from "./FixedBtnView.vue?vue&type=style&index=0&id=1e456c0b&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports